const filterContentForPublic = (content = {}) => {
  const today = new Date();
  const contentEmbargoDate = new Date(content.embargoDate);
  const contentNoEmbargoDate = content.embargoDate === undefined;
  return contentEmbargoDate < today || contentNoEmbargoDate;
};

export default filterContentForPublic;
